/**
 * Non-auth DTOs shared by the API and the web client.
 * Every identifier here is one of our public refs (§7) — never a database uuid
 * and never an identifier minted upstream.
 */
/* ------------------------------------------------------------------ *
 * SIM estate wire shapes — added in Phase 05 because the web client
 * needs them and cannot import from `apps/api`. These are OUR field
 * names; the upstream's never reach this package (§6.1 mapper boundary).
 * ------------------------------------------------------------------ */
/**
 * The most SIMs one lifecycle request may carry.
 *
 * **Ours, not vendor-documented** (§03.5). The lifecycle operations declare
 * their SIM list with no stated ceiling; 100 matches the upstream's own
 * documented cap on comparable batch operations, so it is a defensible bound
 * rather than an invented one. **The UI must say "up to 100 at a time", never
 * "the network refuses"** — and it must not re-declare the number, which is why
 * it lives here rather than in either app.
 */
export const SIM_BATCH_MAX = 100;
/**
 * The nine reasons a disconnect may cite.
 *
 * Part of our own request contract — a client must send one of these — so it
 * belongs in the package both sides import rather than being written out twice.
 */
export const DISCONNECT_REASONS = [
    'NUMBER_NOT_REQUIRED',
    'PRICING_CONCERN',
    'NETWORK_COVERAGE_ISSUE',
    'BILLING_OR_COLLECTION_ISSUE',
    'CONTRACT_EXPIRED',
    'TRANSFER_OF_OWNERSHIP',
    'NO_USAGE',
    'END_USER_TERMINATION',
    'TECHNICAL_SUPPORT_ISSUE',
];
//# sourceMappingURL=dto.js.map